import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/photo',
      name: 'photo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Photo.vue')
    },
    {
      path: '/conception-graphique',
      name: 'conception-graphique',
      component: () => import(/* webpackChunkName: "design" */ './views/ConceptionGraphique.vue')
    },
    {
      path: '/typographie',
      name: 'typographie',
      component: () => import(/* webpackChunkName: "development" */ './views/Typographie.vue')
    },
    {
      path: '/laboratoire-graphique',
      name: 'laboratoire-graphique',
      component: () => import(/* webpackChunkName: "contact" */ './views/LaboratoireGraphique.vue')
    },
    {
      path: '/creation-visuelle-et-sonore',
      name: 'creation-visuelle-et-sonore',
      component: () => import(/* webpackChunkName: "contact" */ './views/CreationVisuelleSonore.vue')
    },
    {
      path: '/creative-writing',
      name: 'creative-writing',
      component: () => import(/* webpackChunkName: "contact" */ './views/CreativeWriting.vue')
    },
    {
      path: '/projets-personnels',
      name: 'projets-personnels',
      component: () => import(/* webpackChunkName: "contact" */ './views/ProjetsPersonnels.vue')
    },
  ]
})
